export default __webpack_public_path__ + "static/logo@1x-reverse-2b33c698ea8fe89d07eba90ce03bad51.png";